import AutoSubmit from '../components/AutoSubmit'
import BulkAction from '../components/BulkAction'

export default class AdminPublicationsJobs {
  constructor(){
    new AutoSubmit()
  }

  index(){
    new BulkAction({
      target: "#pubs-bulk-store",
      action: "#pubs-bulk-action",
      secondary_nav: "#pubs-action-bar",
      checked_scope: "td",
    })
  }

  extensions() {
    new BulkAction({
      target: "#extensions-bulk-store",
      action: "#extensions-bulk-action",
      secondary_nav: "#extensions-action-bar",
      checked_scope: "td",
    })
  }
}
